import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { ChakraProvider } from '@chakra-ui/react'
import system from './theme'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const queryClient = new QueryClient();

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
	<React.StrictMode>
			<ChakraProvider value={system}>
			<QueryClientProvider client={queryClient}>
				<App />
			</QueryClientProvider>
			</ChakraProvider>
	</React.StrictMode>
)
